import { render } from "./DataCollectedSection.vue?vue&type=template&id=9d97c03c"
import script from "./DataCollectedSection.vue?vue&type=script&lang=js"
export * from "./DataCollectedSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__